module.exports = __webpack_public_path__ + "static/media/dashboard-search.7f776bdb.svg";